import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AwsService, HelperService, SwalService, UserProfileService } from '__services';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { APP_ROUTES } from '../../../core/routes/app-routes';

@Component({
  selector: 'app-confirm-sms',
  templateUrl: './confirm-sms.component.html',
  styleUrls: ['./confirm-sms.component.scss', '../login/login.component.scss'],
})
export class ConfirmSmsComponent implements OnInit, OnDestroy {
  isConfirmed = true;
  isLoading = false;
  hide = true;
  confirmForm: FormGroup;
  errorMsg = '';
  successMsg = '';
  user: any;
  isVerified = true;
  phoneNumber = '';
  loginValue = null;
  disableResend = false;
  isMFA = false;
  waitTime = 3 * 60 * 1000;

  private destroy$: Subject<any> = new Subject();

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private awsService: AwsService,
    private userProfileService: UserProfileService
  ) {
    
    
    // this.awsService.confirmSMS
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((user) => {
    //     if (user) {
    //       this.user = user;
    //       this.isMFA =
    //         this.user.challengeName && this.user.challengeName === 'SMS_MFA';
    //       this.isVerified =
    //         !!this.user?.attributes?.phone_number_verified || false;
    //       if (this.isMFA) {
    //         this.phoneNumber =
    //           this.user.challengeParam.CODE_DELIVERY_DESTINATION;
    //         this.awsService.loginValue
    //           .pipe(take(1))
    //           .subscribe((loginValue) => {
    //             this.loginValue = loginValue;
    //           });
    //       } else if (!this.isVerified) {
    //         this.awsService
    //           .verifyCurrentUserAttribute('phone_number')
    //           .then((result) => {
    //           });
    //         this.phoneNumber = this.user.attributes.phone_number;
    //       }
    //     } else {
    //       this.router.navigate([APP_ROUTES.LOGIN]);
    //     }
    //   });
  }

  get confirmFormControls() {
    return this.confirmForm.controls;
  }

  ngOnInit(): void {
    this.user = this.awsService.getCached();
    if (!this.user) {
      this.router.navigate([APP_ROUTES.LOGIN]);
    } else {
      this.awsService.clearCached();
    }
    this.initForm();
  }

  initForm() {
    this.confirmForm = this.fb.group({
      code: [
        '',
        [Validators.required, Validators.maxLength(6), Validators.minLength(6)],
      ],
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  submitForm(): void {
    if(this.isLoading) return;
    this.isLoading = true;
    this.errorMsg = '';

    // if (this.isMFA) {
      this.awsService
        .confirmSignIn(this.confirmFormControls.code.value)
        .then(
          () => {
            this.awsService.callLogin().subscribe(
              (res) => {
                this.errorMsg = '';
                this.userProfileService.setUserFeature(res.role.modules)
                this.userProfileService.setUserProfile(res)
                // localStorage.setItem(
                //   'userFeatures',
                //   JSON.stringify(res.role.modules)
                // );
              },
              (err) => {
                this.isLoading = false;
                this.errorMsg = err.message;
              },
              () => {
                this.awsService.loginValue.next(null);
                this.router.navigate([APP_ROUTES.DASHBOARD], {
                  replaceUrl: true,
                });
              }
            );
          },
          (err) => {
            if (err.__type && err.__type === 'NotAuthorizedException') {
              this.errorMsg = 'Session expired.';
              this.router.navigate([APP_ROUTES.LOGIN]);
              return;
            }
            this.errorMsg = 'Invalid Code.';
            this.successMsg = '';
            this.isLoading = false;
          }
        );
    // } 
    // else {
    //   this.awsService
    //     .verifyCurrentUserAttributeSubmit(
    //       'phone_number',
    //       this.confirmFormControls.code.value
    //     )
    //     .then(
    //       () => {
    //         this.awsService.callLogin().subscribe(
    //           (res) => {
    //             this.userProfileService.setUserFeature(res.role.modules)
    //             this.userProfileService.setUserProfile(res)
    //             // localStorage.setItem(
    //             //   'userFeatures',
    //             //   JSON.stringify(res.role.modules)
    //             // );
    //             this.awsService.setPreferredMFA(this.user);
    //           },
    //           (err) => {
    //             this.isLoading = false;
    //             this.errorMsg = err.message;
    //           },
    //           () => {
    //             this.router.navigate([APP_ROUTES.DASHBOARD], {
    //               replaceUrl: true,
    //             });
    //           }
    //         );
    //       },
    //       (err) => {
    //         if (err.__type && err.__type === 'NotAuthorizedException') {
    //           this.errorMsg = 'Session expired.';
    //           this.router.navigate([APP_ROUTES.LOGIN]);
    //           return;
    //         }
    //         this.errorMsg = 'Invalid Code.';
    //         this.successMsg = '';
    //         this.isLoading = false;
    //       }
    //     );
    // }
  }

  resendCode() {
    if (this.disableResend) return true;
    if (!this.isMFA) {
      this.disableResend = true;
      setTimeout(() => {
        this.disableResend = false;
      }, this.waitTime);
      const { username, password } = this.user;
      this.awsService.login({ username, password }).then(
        (result) => {
          SwalService.success('The code has been resent');
        },
        (err) => {
          SwalService.error(err.message);
        }
      );
      return;
    }
    if (!this.loginValue || !this.loginValue.email) {
      SwalService.error('Cannot resend code.');
      this.backToLogin();
      return;
    }
    this.disableResend = true;
    setTimeout(() => {
      this.disableResend = false;
    }, this.waitTime);
    const { email, password } = this.loginValue;
    this.awsService.login({ username: email, password }).then(
      () => {},
      (err) => {
        SwalService.error(err.message);
      }
    );
  }

  backToLogin(): void {
    this.router.navigate([APP_ROUTES.LOGIN]);
  }

  getToday(): string {
    return HelperService.getToday();
  }
}
